import viewportUnitsBuggyfill from 'viewport-units-buggyfill';

viewportUnitsBuggyfill.init({
	hacks: viewportUnitsBuggyfill.hacks,
	refreshDebounceWait: 250
});

// orientationchange
// window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true);


let scrollCache = 0;
window.scrollCache = scrollCache;


/**
 * Library
 * 読み込むだけで使えるようなライブラリーはここにインポートしてください
 * 設定が必要なライブラリーは、vendor/_sample.js のようにvendorディレクトリに入れてインポートしてください
 */
// import 'lity';


/**
 * 作成したもの
 */
import CommonCtrl from '@/include/_common';
import ScrollCtrl from '@/include/_scroll';
// import ScrollDownCtrl from '@/include/_scrolldown';
import NaviCtrl from '@/include/_gnavi';
// import SearchCtrl from '@/include/_search';
import TouchCtrl from '@/include/_touch';

new CommonCtrl();
new NaviCtrl();
// new SearchCtrl();
new TouchCtrl('a, button');
new ScrollCtrl();
// new ScrollDownCtrl();

